// @ts-nocheck
import React from 'react'
import cx from 'classnames'
import * as R from 'ramda'

import { FadeScale } from 'components/shared/Transitions/FadeScale/FadeScale'
import { Icon } from 'components/shared/Icon/Icon'

import { getStatuses } from './model'

import styles from './Status.module.scss'

export const Status = ({ timeout = 200, isFinished, isInvalid }) => {
  const statuses = getStatuses({ isFinished, isInvalid })

  if (R.all(status => !status.isInitialised)(statuses)) {
    return null
  }

  return (
    <span className={styles.status}>
      {R.map(
        ({ icon, id, ref, type, isInitialised }) => (
          <FadeScale
            className={cx(styles.icon, styles[type])}
            key={id}
            {...{ ref, timeout, isInitialised }}
          >
            <Icon size={16} {...{ icon, ref }} />
          </FadeScale>
        ),
        statuses,
      )}
    </span>
  )
}
